/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { setCustomerConversionFollow, getCustomerConversionFollowListByCustomerConversionId } from '@/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import DUploadFile from '@/components/uploadFile/index.vue'

import {Loading} from "element-ui";
import axios from "axios";
import {getMarketClueFollowList, setMarketClueFollow} from "@/api/common";
import {delNullProperty} from "@/utils";
@Component({
    components: { DUploadFile }
})
export default class Fllow extends Vue {
    fileList: { name: string; url: string }[] = []
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number
    name = ''
    recordId: string|null = ''
    tableLoading = false

    flag = false // 是否修改过时间没如果修改过就给后台传值
    disBtn = false
    formModel = {
        stage:'',
        content:'',
    }
    formRules = {
        stage: [{required: true, message: '请选择卡点阶段', trigger: 'change'}],
        content: [{required: true,message: '请输入回访内容',trigger: ['blur', 'change']}],
    }
    reasonProp = ''
    stageList = [
        '一句话不说',
        '回复画像后消失',
        '报价消失/费用劝退',
        '时间不着急',
        '其他原因'
    ]
    pageSize = 20
    timer = null
    status = ''
    loading = false

    menuBtn = menuBtn

    created() {
        this.$nextTick(() => {
            (this.$refs['el-table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {
                        return
                    }
                    this.limit += 20
                }
            }, true);
        })

        // 拿到当前转化客户的id
        this.recordId = this.$route.query.id as string
        this.name = this.$route.query.name as string
        this.status = this.$route.query.status as string == '2' ? '已下发' : '' // 状态为已下发 ，不展示卡点阶段
        this.getTableData()

    }

    // methods
    async confirm() {
        let isConfirmFlag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                isConfirmFlag = false
            }
        })
        const obj = {
            idList: [this.recordId],
            stage: this.formModel.stage ? this.formModel.stage : '',
            content: this.formModel.content,
        }

        if (isConfirmFlag) {
            this.disBtn = true
            this.loading = true;
            await setMarketClueFollow(obj).then(()=>{
                this.$nextTick(() => {
                    this.getTableData()
                    this.formModel.stage = ''
                    this.formModel.content = ''
                    this.$message.success('新增回访记录成功')
                    this.flag = false
                    this.disBtn = false
                    this.loading = false
                })
            }).catch(err=>{
                this.flag = false
                this.disBtn = false
                this.loading = false
            })
        }
    }

    async getTableData() {
        if (this.menuBtn(68)) return
        this.tableLoading = true
        await getMarketClueFollowList(delNullProperty({
            id: this.recordId,
            limit: this.limit,
            page: this.page
        })).then((data: any) => {
            this.total = data.allNum
            this.tableData = data.marketClueFollowList
            this.tableLoading = false
        }).catch(err => {
            this.tableLoading = false
        })
    }

  

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(val: number) {
        this.pageSize = val
        this.getTableData()
    }

}
